import React, { useState } from "react"
import { Link } from "react-router-dom"
import Heading from "../../common/heading/Heading"
import { useAuth } from "../../../context/AuthContext"
import AuthModal from "../../auth/AuthModal"
import "./Hero.css"

const Hero = () => {
  const { isUser, isAdmin } = useAuth()
  const [modalOpen, setModalOpen] = useState(false)
  const [modalMode, setModalMode] = useState("login")

  const openModal = (mode) => { setModalMode(mode); setModalOpen(true) }

  return (
    <>
      <section className="hero">
        <div className="container">
          <div className="row">
            <Heading
              subtitle="WELCOME TO ROVERS ACCESS LIMITED"
              title="The Pulse of Trading in the Financial Markets"
            />
            <p className="hero-motto">"GAMBLING IS NOT TRADING."</p>
            <p>
              Headquartered in Nairobi, Kenya — practical, technology-based trading
              education in Forex, Futures &amp; Options. Small classes. Real mentors.
              Real markets.
            </p>

            <div className="button">
              {isUser ? (
                <Link to="/dashboard" className="primary-btn hero-btn">
                  Go to Dashboard <i className="fa fa-long-arrow-alt-right"></i>
                </Link>
              ) : isAdmin ? (
                <Link to="/admin/dashboard" className="primary-btn hero-btn">
                  Admin Panel <i className="fa fa-long-arrow-alt-right"></i>
                </Link>
              ) : (
                <>
                  <button
                    className="primary-btn hero-btn"
                    onClick={() => openModal("register")}
                  >
                    ENROLL NOW <i className="fa fa-long-arrow-alt-right"></i>
                  </button>
                  <button
                    className="hero-btn hero-btn-outline"
                    onClick={() => openModal("login")}
                  >
                    SIGN IN <i className="fa fa-long-arrow-alt-right"></i>
                  </button>
                </>
              )}
              <Link to="/courses" className="hero-btn hero-btn-ghost">
                VIEW PROGRAMMES <i className="fa fa-long-arrow-alt-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <div className="margin"></div>

      <AuthModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        mode={modalMode}
      />
    </>
  )
}

export default Hero
